export const SUPPORT_CONTACT_FORM_URL = "https://support.clipboardhealth.com/hc/en-us/requests/new";
